import { render, staticRenderFns } from "./BusinessTypes.vue?vue&type=template&id=716d642e&scoped=true"
import script from "./BusinessTypes.vue?vue&type=script&lang=js"
export * from "./BusinessTypes.vue?vue&type=script&lang=js"
import style0 from "./BusinessTypes.vue?vue&type=style&index=0&id=716d642e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d642e",
  null
  
)

export default component.exports